import {
  Component,
  HostListener,
  Input,
  OnInit,
  Output,
  EventEmitter,
} from '@angular/core';
import { ViewCell } from 'ng2-smart-table';
@Component({
  selector: 'app-smart-table-cell-with-ellipsis',
  templateUrl: './smart-table-cell-with-ellipsis.component.html',
  styleUrls: ['./smart-table-cell-with-ellipsis.component.scss'],
})
export class SmartTableCellWithEllipsisComponent implements ViewCell, OnInit {
  @Input() value: any; // Value which comes in from the parent component, needs to be parsed
  @Output() byLinkClick = new EventEmitter();
  @Output() byLinkClickRowDataEmit = new EventEmitter();
  rowData: any; // Data for row
  rowValue: { display: string[]; hide: string[] } = { display: [], hide: [] }; // Row value stores some values to display and others to hide
  decorate: boolean = false; // If decorate is true: items would go inside badge-pills
  isRowList: boolean = false;
  defaultDisplay: number = 2;
  truncateAfter: number = 15;
  status: string = 'primary'; //Primary will be set by default
  noDataMessage: string = 'N/A';
  showAsLink: boolean = false;
  extraData: {} = {};
  dataObject: boolean = false;
  url: string = '';
  allURLs: string[];
  linkUnderline: boolean = false;
  linkClass: string = '';
  removeTagTopSpacing: boolean = false;
  nonLinkClass: string = '';
  wrapContent: boolean = false;
  openDialog: boolean = false;

  // Parse the input value and initialize rowData and decorate flag
  ngOnInit() {
    try {
      let parsedValue = JSON.parse(this.value);
      this.decorate = parsedValue?.decorate;
      this.rowData = parsedValue?.data;
      this.noDataMessage = parsedValue?.noDataMessage || 'N/A';
      this.truncateAfter = parsedValue?.truncateAfter;
      if (parsedValue?.defaultDisplay) {
        this.defaultDisplay = parsedValue?.defaultDisplay;
      }
      if (parsedValue?.allURLs) {
        this.allURLs = parsedValue?.allURLs;
      }
      this.status = parsedValue?.status || 'primary';
      this.showAsLink = parsedValue?.showAsLink || false;
      this.extraData = parsedValue?.extraData || {};
      this.dataObject = parsedValue?.dataObject || false;
      this.isRowList = Array.isArray(this.rowData);
      this.isRowList
        ? this.buildRows(this.defaultDisplay)
        : this.buildSingleEntry(this.truncateAfter);
      this.linkUnderline = parsedValue?.linkUnderline || false;
      this.linkClass = parsedValue?.linkClass || '';
      this.removeTagTopSpacing = parsedValue?.removeTagTopSpacing;
      this.url = parsedValue?.url;
      this.nonLinkClass = parsedValue?.nonLinkClass || '';
      this.wrapContent = parsedValue?.wrapContent || false;
      this.openDialog = parsedValue?.openDialog || false;
    } catch (error) {}
  }

  // Puts first X entries in display and others in hidden
  // [Can add host listener in future and update defaultDisplay value with changing width of screen]
  buildRows(defaultDisplay) {
    for (let i = 0; i < this.rowData?.length; i++) {
      if (i < defaultDisplay) {
        if (
          !this.decorate &&
          i != defaultDisplay - 1 &&
          i != this.rowData?.length - 1
        ) {
          !this.dataObject ? (this.rowData[i] += ', ') : null;
        }
        this.rowValue.display.push(this.rowData[i]);
      } else {
        if (!this.decorate && i != this.rowData?.length - 1) {
          !this.dataObject ? (this.rowData[i] += ', ') : null;
        }
        this.rowValue.hide.push(this.rowData[i]);
      }
    }
  }

  buildSingleEntry(truncateAfter = 15) {
    this.rowValue.display = [
      (this.rowData as string)?.substring(0, truncateAfter),
    ];
    if (this.rowData?.length > truncateAfter) {
      this.rowValue.hide = [(this.rowData as string).substring(0)];
    } else {
      this.rowValue.hide = [''];
    }
  }

  navigateEvent(row) {
    this.byLinkClick.emit(row);
    let updatedValue = {
      ...JSON.parse(this.value),
      clickedItem: row,
    };
    this.byLinkClickRowDataEmit.emit(updatedValue);
  }

  @Output() byMoreClick = new EventEmitter();
  onMoreClick(event) {
    if (this.openDialog) {
      event.stopPropagation();
      this.byMoreClick.emit(this.extraData);
    }
  }
}
